import { gql } from '@apollo/client';
const SET_ORDER_COMPONENT_VARIANT_CONSUMPTION_OVERRIDE = gql `
  mutation SetOrderComponentVariantConsumptionOverride(
    $orderComponentVariantId: ID!
    $value: Float!
  ) {
    setOrderComponentVariantConsumptionOverride(
      orderComponentVariantId: $orderComponentVariantId
      value: $value
    ) {
      orderComponentVariant {
        id
      }
    }
  }
`;
export default SET_ORDER_COMPONENT_VARIANT_CONSUMPTION_OVERRIDE;
